<template>
  <v-card elevation="3" class="rounded-lg">
    <v-card-text>
      <v-row v-if="client">
        <v-col cols="8">
          <v-row>
            <v-col class="pb-0">
              <span class="black--text font-weight-bold">
                {{
                  client.billingInformation
                    ? client.billingInformation.companyName
                    : ""
                }}
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <span class="regulartext">
                {{ client.name }}
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <span>
                {{ client.email }}
              </span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-row class="fill-height text-end">
            <v-col cols="12">
              <v-icon
                :color="client.isOnList ? 'primary' : ''"
                @click="addFavorite"
              >
                mdi-thumb-up
              </v-icon>
            </v-col>
            <v-col cols="12" align-self="end" class="pb-0">
              <span class="smalltext"> {{ client.phone }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
//vuex
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    menu: [],
  }),
  created() {
    this.menu = [{ text: this.translations.label_update, value: "update" }];
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
  },
  methods: {
    ...mapActions("user", ["addOrRemoveFromFav"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    async addFavorite() {
      try {
        let isOnList = this.client.isOnList;
        isOnList = !isOnList;
        let payload = {
          clientId: this.client._id,
          addToList: isOnList,
        };
        let response = await this.addOrRemoveFromFav(payload);
        if (!response) throw response;
        let message = isOnList
          ? this.translations.label_added_to_favorites
          : this.translations.label_removed_from_favorites;
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: message,
          timeout: 1000,
        });
        this.$emit("fetchData");
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
  },
};
</script>

<style scoped>
.smalltext {
  font-size: 0.92em;
}
.regulartext {
  font-size: 0.9em;
}
</style>
